/**
 *  TutorialLadder
 *
 *  Created by Legman on 08/06/2017.
 *
 */

import Common from "../Common";
import Tutorial from "./Tutorial";

/**
 * @class
 * @extends Tutorial
 */
export default class TutorialLadder extends Tutorial {
    constructor() {
        super();

        this._marker = null;
    }

    show() {
        super.show(translate("tutorial_leaderboard"));

        const assets = Common.assets;
        this._marker = new PIXI.Sprite(assets.getTexture("ui_tut_circle"));
        this._marker.y = 194;
        this._marker.anchor = new PIXI.Point(0.5, 0.5);
        this._marker.scale = new PIXI.Point(5, 5);
        this.addChildAt(this._marker, 0);
    }

    resize() {
        this._marker.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 90;
    }
}